require("../../base/js/app.js");
require("bootstrap-datepicker");

// Coupon copy code, only works on https
const couponCopyBtns = document.querySelectorAll(".js-coupon__copy");

if (couponCopyBtns.length > 0) {
    couponCopyBtns.forEach(btn => {
        btn.addEventListener("click", e => {
            e.preventDefault();

            const codeText = btn
                .closest(".js-coupon")
                .querySelector(".js-coupon__input");

            codeText.select();
            codeText.setSelectionRange(0, 99999);

            navigator.clipboard.writeText(codeText.value);
        });
    });
}

function closeCouponModal(e) {
    e.preventDefault();
    sessionStorage.setItem("vgz-questions", "true");
    couponModal.remove();
}

function goToQuestions(e) {
    closeCouponModal(e);
    window.location =
        "https://survey.alchemer.eu/s3/90794283/Collectief-Voordeel";
}

let couponStorage = sessionStorage.getItem("vgz-questions");

var couponModal = document.createElement("div");

couponModal.innerHTML = `<h1>Wat vind jij van Collectief Voordeel?</h1><p>Heb jij 2 minuten tijd en wil je ons helpen met jouw mening?</p><p style=\"text-align: center;margin: 0;\"></p>`;
couponModal.id = "sg-popup";

var btnYes = document.createElement("button");
btnYes.className = "btn btn-primary mb-3";
btnYes.style.display = "block";
btnYes.style.width = "100%";
btnYes.type = "button";
btnYes.innerText = "Beantwoord een aantal korte vragen";
btnYes.addEventListener("click", e => {
    goToQuestions(e);
});
couponModal.appendChild(btnYes);

var btnNo = document.createElement("a");
btnNo.innerText = "Nee, bedankt";
btnNo.href = "#";
btnNo.style.display = "block";
btnNo.style.textAlign = "center";
btnNo.addEventListener("click", e => {
    closeCouponModal(e);
});
couponModal.appendChild(btnNo);

window.setTimeout(function() {
    if (couponStorage === null) {
        document.body.appendChild(couponModal);
    }
}, 30000);



// WEBPACK FOOTER //
// ./resources/assets/vgz/js/app.js